import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';
import type { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { getItemPath, getPathForHistory } from 'reactApp/modules/viewer/sagas/navigate.saga';
import { vkTeamsBridge } from 'reactApp/modules/vkTeam/vkTeam.module';
import { generateUuidV4 } from 'reactApp/utils/helpers';

export const isEnabledMultiWindow = () => {
    const userAgent = window.navigator?.userAgent;
    return isFeature('multi-window') && Boolean((window as any).qt) && IS_MY_TEAM && userAgent.includes('VKT/desktop');
};

export const openNewWindow = (url: string) => {
    vkTeamsBridge.send('OpenModal', {
        url: `${window.location.origin}${url}`,
        uid: generateUuidV4(),
        size: 1080,
        minSize: 800,
    });
};

export const getWindowUrl = (storage: EStorageType, item: CloudItem) => {
    const { fullPath } = getItemPath(storage, item);
    return getPathForHistory(fullPath, storage);
};
